import React, { useState, useEffect } from "react";

// Kanban Board View
import Board from "react-trello";
import "../Assets/css/style.css";
import {
  Card,
  Stack,
  Container,
  Typography,
  Tooltip,
  IconButton,
  Button,
  TextField,
  Grid,
  Box,
  Tab,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Select from "react-select";
import Page from "../components/Page";
import moment from "moment";
import { notification } from "src/utils/messages";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import {
  AutoGraphSharp,
  EditSharp,
  LeaderboardSharp,
  PersonAddAltSharp,
  Close,
  ChangeCircle,
  Check,
  SendSharp,
  ThumbUpAlt
} from "@mui/icons-material";
import {
  getPrimeConfirmMembersList,
  getPrimeMemberWelcomeKitDataExport,
  insertWelcomeKitFollowUp,
  updateMemberWelcomeKitStatus
} from "../api/commonapi";
import DataTable from "react-data-table-component";
import { CSVLink } from "react-csv";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import { fetchPrimeleadhistory, fetchPrimeMemberWelcomeKithistory } from "src/utils/common";
import { IsNotValue } from "src/constant/variable";
import CustomLoader from "src/components/CustomLoader";

export default function WelcomeKit() {
  let loginUser = JSON.parse(localStorage.getItem("userData"));
  const [step, setStep] = useState(0);
  // Tab View
  const [value, setValue] = useState("1");

  const [myModal, setMyModal] = useState({
    mval: false,
    p_lead_id: 0,
    l_phase: 0
  });
  const [memberHistory, setMemberHistory] = useState([]);

  const [filterlead, setfilterlead] = useState({
    u_type: loginUser.u_type,
    filterl: "",
    address_filled: 0,
    s_date: null,
    e_date: null,
    l_phase: -1,
    lead_status: -1
  });

  const [newleadData, setnewLeadData] = useState([]);
  const [leadStatusChangeModal, setLeadStatusChangeModal] = useState(false);
  const [followUpModal, setFollowUpModal] = useState(false);
  const [isFormSubmit, setIsFormSubmit] = useState(false);
  const [followUpData, setFollowUpData] = useState({
    u_id: loginUser.u_id
  });

  useEffect(() => {
    setFollowUpData({ ...followUpData, m_id: memberHistory?.memberdetails?.m_id });
  }, [memberHistory]);

  const [leadHistory, setLeadHistory] = useState([]);
  const [expanded, setExpanded] = useState(0);
  const closeLeadStatusChangeModal = () => {
    setLeadStatusChangeModal(false);
    setLeadStatusChangeData({
      m_id: 0, // Lead ID
      l_phase: 0, // Updated Lead Status
      u_id: loginUser?.u_id || 0, // User ID
      from_l_phase: 0 // Old Lead Status
    });
  };

  const [leadStatusChangeData, setLeadStatusChangeData] = useState({
    m_id: 0, // Lead ID
    l_phase: 0, // Updated Lead Status
    u_id: loginUser?.u_id || 0, // User ID
    from_l_phase: 0 // Old Lead Status
  });

  const statusList = [
    { value: 0, label: "Waiting For Welcome Kit" },
    { value: 2, label: "Ready to Ship" },
    { value: 1, label: "Courier Delivered" },
    { value: 4, label: "Incorrect Address" }
  ];

  const addressFiledData = [
    { value: 1, label: "Address Filled" },
    { value: 2, label: "Address Not Filled" }
  ];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px"
  };

  const followupstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    padding: "10px"
  };

  useEffect(async () => {
    getAllConfirmPrimeMembersLead();
  }, []);

  const initNewLan = {
    allLeadList: [],
    allLeadIds: [],
    waitingForWelcomeKitLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    readyForCourierLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    courierDeliveredLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    incorrectAddressLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  };
  const [newLan, setNewLan] = useState({
    allLeadList: [],
    allLeadIds: [],
    waitingForWelcomeKitLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    readyForCourierLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    courierDeliveredLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    },
    incorrectAddressLead: {
      counter: 0,
      leadList: [],
      id_array: [],
      is_no_more: false
    }
  });
  const getAllConfirmPrimeMembersLead = async (newState = false) => {
    setLoading(true);
    const [
      waitingForWelcomeKitLead,
      readyForCourierLead,
      courierDeliveredLead,
      incorrectAddressLead
    ] = await Promise.all([
      // Waiting for welcome kit
      getPrimeConfirmMembersList({
        ...(newState ? newState : filterlead),
        l_phase: 0,
        id_array: []
      }),
      // ready for courier
      getPrimeConfirmMembersList({
        ...(newState ? newState : filterlead),
        l_phase: 2,
        id_array: []
      }),
      // courier delivered
      getPrimeConfirmMembersList({
        ...(newState ? newState : filterlead),
        l_phase: 1,
        id_array: []
      }),
      // courier delivered
      getPrimeConfirmMembersList({
        ...(newState ? newState : filterlead),
        l_phase: 4,
        id_array: []
      })
    ]);
    setLoading(false);

    if (waitingForWelcomeKitLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, waitingForWelcomeKitLead, "waitingForWelcomeKitLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
    if (readyForCourierLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, readyForCourierLead, "readyForCourierLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
    if (courierDeliveredLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, courierDeliveredLead, "courierDeliveredLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
    if (incorrectAddressLead.status == 1) {
      setNewLan((prevState) =>
        updateAPIDataToState(prevState, incorrectAddressLead, "incorrectAddressLead")
      );
    } else {
      setNewLan((prevState) => prevState);
    }
  };

  const getFilterLeadData = async () => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      waitingForWelcomeKitLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      readyForCourierLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      courierDeliveredLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      incorrectAddressLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });
    if (filterlead.lead_status != -1) {
      // go for Specific lead Status
      await handleCustomLaneScroll(filterlead.lead_status, true);
    } else {
      // get All Lead
      await getAllConfirmPrimeMembersLead();
    }
  };

  const resetSearchForm = async (newState) => {
    setNewLan({
      allLeadList: [],
      allLeadIds: [],
      waitingForWelcomeKitLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      readyForCourierLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      courierDeliveredLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      },
      incorrectAddressLead: {
        counter: 0,
        leadList: [],
        id_array: [],
        is_no_more: false
      }
    });

    await getAllConfirmPrimeMembersLead(newState);
  };

  const updateAPIDataToState = (prevState, newResponse, lead_key) => {
    const { leadList } = newResponse.data;
    const { counter } = newResponse.data;
    return {
      ...prevState,
      ["allLeadList"]: [...prevState["allLeadList"], ...setDataInCard(leadList)],
      ["allLeadIds"]: [
        ...prevState["allLeadIds"],
        ...leadList?.map((lead) => {
          return lead?.m_id;
        })
      ],
      [lead_key]: {
        ...prevState[lead_key],
        counter: counter,
        id_array: [...prevState[lead_key].id_array, ...leadList?.map((lead) => lead.m_id)],
        is_no_more: leadList.length < 20 ? true : false
      }
    };
  };

  const setDataInCard = (list) => {
    return list.map((e, key) => {
      return {
        id: e.m_id,
        taskTitle: e.m_name,
        JoiningDate: e.joining_date,
        body: e.m_name,
        contactNo: e.mobile_no,
        pincode: e.pr_pincode,
        businessName: e.business_name,
        welcomeKitAddress: e.pr_welcome_kit_address,
        prWelkitAddressFill: e.pr_wel_kit_address_fill,
        metadata: { id: e.m_id },
        phase: e.pr_welcome_kit_status,
        tags: {
          cardId: e.m_id
        },
        lastElement: key == list.length - 1 ? true : false
      };
    });
  };

  const [loadingMoreData, setLoadingMoreData] = useState(-1);
  const handleCustomLaneScroll = async (laneId, isCallFromSearch = false) => {
    let lead_key =
      laneId == 0
        ? "waitingForWelcomeKitLead"
        : laneId == 2
          ? "readyForCourierLead"
          : laneId == 1
            ? "courierDeliveredLead"
            : laneId == 4
              ? "incorrectAddressLead"
              : "";

    if (isCallFromSearch || newLan[lead_key].is_no_more != true) {
      if (loadingMoreData != laneId) {
        setLoading(true);
        setLoadingMoreData(laneId);
        let resp = await getPrimeConfirmMembersList({
          ...filterlead,
          l_phase: laneId,
          id_array: isCallFromSearch ? [] : newLan["allLeadIds"]
        });
        setLoading(false);

        if (resp.status == 1) {
          let newDataList = resp.data.leadList;
          let counter = resp.data.counter;
          setNewLan((prevState) => ({
            ...prevState,
            ["allLeadList"]: [...prevState["allLeadList"], ...setDataInCard(newDataList)],
            ["allLeadIds"]: [
              ...prevState["allLeadIds"],
              ...newDataList?.map((lead) => {
                return lead?.m_id;
              })
            ],

            [lead_key]: {
              ...prevState[lead_key],
              counter: counter,
              id_array: [...prevState[lead_key].id_array, ...newDataList?.map((lead) => lead.m_id)],
              is_no_more: newDataList.length < 20 ? true : false
            }
          }));
          setLoadingMoreData(-1);
        } else {
          setNewLan((prevState) => prevState);
          setLoadingMoreData(-1);
        }
      }
      setLoadingMoreData(-1);
    }
    setLoadingMoreData(-1);
  };

  const welcomeKitStatusChange = async (cardId, targetLaneId, sourceLaneId) => {
    // Prevent same-lane movement
    if (targetLaneId === sourceLaneId) return;

    // 🚫 Don't allow Delivered Kit to Waiting Stage
    if (sourceLaneId == 1 && targetLaneId == 0) {
      let notify = notification({
        type: "error",
        message: "You cannot move a Delivered Kit to Waiting Stage"
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllConfirmPrimeMembersLead();
      return;
    }
    // 🚫 Don't allow Offline lead to go to Signup
    if (sourceLaneId == 1 && targetLaneId == 2) {
      let notify = notification({
        type: "error",
        message: "You cannot move a Delivered Kit to Ready to Ship"
      });
      notify();
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllConfirmPrimeMembersLead();
      return;
    }

    // ✅ Default status update
    let lfdata = new FormData();
    lfdata.append("m_id", cardId);
    lfdata.append("l_phase", targetLaneId);
    lfdata.append("u_id", loginUser.u_id);
    lfdata.append("from_l_phase", sourceLaneId);
    const updateResp = await updateMemberWelcomeKitStatus(lfdata);
    let notify = notification({
      type: updateResp.status == 0 ? "error" : "success",
      message: updateResp.message
    });
    notify();
    if (updateResp.status == 1) {
      setNewLan(initNewLan);
      closeLeadStatusChangeModal();
      await getAllConfirmPrimeMembersLead();
    }
  };

  // KanBan Board
  let len = [[], [], [], [], [], [], [], []];
  newleadData?.map((e, key) => {
    let temp = {
      id: e.m_id,
      taskTitle: e.m_name,
      JoiningDate: e.joining_date,
      body: e.m_name,
      contactNo: e.mobile_no,
      pincode: e.pr_pincode,
      businessName: e.business_name,
      welcomeKitAddress: e.pr_welcome_kit_address,
      prWelkitAddressFill: e.pr_wel_kit_address_fill,
      metadata: { id: e.m_id },
      phase: e.pr_welcome_kit_status,
      tags: {
        cardId: e.m_id
      }
    };
    len[e.l_phase].push(temp);
  });

  const leadList = {
    lanes: [
      {
        id: "0",
        title: "Waiting For Welcome Kit",
        className: "taskListColumn openTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 0),
        label: newLan.waitingForWelcomeKitLead.counter,
        currentPage: 1,
        // style: { position: "relative" }
        style: {
          position: "relative",
          // height: "calc(100vh - 180px)",
          overflowY: "auto"
        }
      },
      {
        id: "2",
        title: "Ready to Ship",
        className: "taskListColumn openTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 2),
        label: newLan.readyForCourierLead.counter,
        currentPage: 1,
        // style: { position: "relative" }
        style: {
          position: "relative",
          // height: "calc(100vh - 180px)",
          overflowY: "auto"
        }
      },
      {
        id: "1",
        title: "Courier Delivered",
        className: "taskListColumn finishTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 1),
        label: newLan.courierDeliveredLead.counter,
        currentPage: 1,
        // style: { position: "relative" }
        style: {
          position: "relative",
          // height: "calc(100vh - 180px)",
          overflowY: "auto"
        }
      },
      {
        id: "4",
        title: "Incorrect Address",
        className: "taskListColumn finishTask",
        cards: newLan.allLeadList.filter((item) => item.phase == 4),
        label: newLan.incorrectAddressLead.counter,
        currentPage: 1,
        // style: { position: "relative" }
        style: {
          position: "relative",
          // height: "calc(100vh - 180px)",
          overflowY: "auto"
        }
      }
    ]
  };

  const CustomCard = ({
    onClick,
    taskTitle,
    body,
    contactNo,
    pincode,
    JoiningDate,
    businessName,
    welcomeKitAddress,
    subTitle,
    tags,
    showDeleteButton,
    onDelete,
    person,
    phase,
    id,
    lastElement,
    prWelkitAddressFill
  }) => {
    const clickDelete = (e) => {
      onDelete();
      e.stopPropagation();
    };

    const handleRightClick = (e) => {};

    return (
      <>
        <div id={id} phase={phase} className="myCard" style={{ position: "relative" }}>
          <div
            className="taskCard"
            style={{
              position: "relative",
              background:
                phase == 4 && prWelkitAddressFill == 0
                  ? "rgb(255, 167, 133)"
                  : phase == 4 && prWelkitAddressFill == 1
                    ? "rgb(255, 206, 99)"
                    : ""
            }}
          >
            <div>
              <header
                className="taskHeader"
                style={{ paddingBottom: "8px" }}
                onClick={() => {
                  setLeadStatusChangeData({
                    ...leadStatusChangeData,
                    m_id: id,
                    from_l_phase: phase
                  });
                  setLeadStatusChangeModal(true);
                }}
              >
                <div className="TaskTitle">{taskTitle}</div>
                <a
                  className=""
                  style={{ position: "absolute", right: "0px", zIndex: "0" }}
                  onClick={() => {
                    setLeadStatusChangeData({
                      ...leadStatusChangeData,
                      m_id: id,
                      from_l_phase: phase
                    });
                    setLeadStatusChangeModal(true);
                  }}
                >
                  <Tooltip title="Change Lead Status" style={{ padding: 0, margin: 0 }}>
                    <IconButton>
                      <ChangeCircle color="success" style={{ height: "20px", width: "20px" }} />
                    </IconButton>
                  </Tooltip>
                </a>
                {showDeleteButton && <div onClick={clickDelete} />}
              </header>
              <div className="taskBody" onContextMenu={handleRightClick} onClick={onClick}>
                <p>
                  <b>Name: </b> {taskTitle}
                </p>
                <p>
                  <b>Contact: </b> {contactNo}
                </p>
                <p>
                  <b>Business Name:</b> {businessName}
                </p>
                <p>
                  <b>Pincode: </b> {pincode}
                </p>
                <p>
                  <b>Welcome Kit Address </b>: {welcomeKitAddress}
                </p>
              </div>
              <div className="taskUserDetail">
                <div className="taskDate">
                  <p>
                    <b>Joining Date :</b> {JoiningDate}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {loadingMoreData == phase && lastElement ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <CircularProgress color="primary" fourColor variant="indeterminate" />
          </div>
        ) : (
          <></>
        )}
      </>
    );
  };

  const cancelModal = () => {
    setMyModal({ mval: false, m_id: 0, l_phase: 0 });
    setFollowUpModal(false);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const expo_columns = [
    { label: "No", key: "m_id" },
    { label: "Member Name", key: "m_name" },
    { label: "Contact No", key: "mobile_no" },
    { label: "Email", key: "m_email_id" },
    {
      label: "Join Date",
      key: "joining_date"
    },
    { label: "Business Name", key: "business_name" },
    { label: "Business Category", key: "business_category" },
    { label: "Occupation Type", key: "occupation_type" },
    { label: "Business Since", key: "business_since" },
    { label: "Business Description", key: "business_desc" },
    { label: "Business Address", key: "b_address" },
    { label: "Pincode", key: "pr_pincode" },
    { label: "Business Mobile", key: "b_mobile_no" },
    { label: "Business Email Address", key: "b_email_id" },
    { label: "Welcome Kit Address", key: "pr_welcome_kit_address" },
    { label: "DOB", key: "dob" },
    { label: "Blood Group", key: "blood_group" },
    { label: "Website URL", key: "website_url" },
    { label: "Facebook URL", key: "fb" },
    { label: "Instagram URL", key: "instagram" },
    { label: "LinkedIn URL", key: "linkedin" },
    { label: "Twitter URL", key: "twitter" },
    { label: "YouTube URL", key: "youtube" }
  ];

  const [exportLeadList, setExportLeadList] = useState([]);
  const [loading, setLoading] = useState(false);
  const exportFilteredData = async (event, done) => {
    setExportLeadList([]);
    setLoading(true);
    let resp = await getPrimeMemberWelcomeKitDataExport({
      ...filterlead,
      type: 0
    });

    if (resp.status == 1) {
      setExportLeadList(resp?.data);
      downloadCSV(resp.data);
    } else {
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
    setLoading(false);
  };

  const downloadCSV = (data) => {
    // return exportLeadList;
    const csvContent =
      `${expo_columns?.map((column) => column.label).join(",")}\n` +
      `${data
        ?.map((row) =>
          expo_columns
            ?.map((column) => {
              // Convert value to string
              // const value = (row[column.key] || "").toString();
              const value =
                row[column.key] == undefined ||
                row[column.key] === null ||
                row[column.key] === "null"
                  ? ""
                  : row[column.key].toString();
              return `"${value.replace(/"/g, '""')}"`; // Escape double quotes and enclose in quotes
            })
            .join(",")
        )
        .join("\n")}`;
    // `${data
    //   .map((row) =>
    //     expo_columns?.map((column) => row[column.key] || "").join(",")
    //   )
    //   .join("\n")}`;

    // Create Blob from CSV content
    const blob = new Blob([csvContent], { type: "text/csv" });
    // Create URL for the Blob
    const blobUrl = window.URL.createObjectURL(blob);

    // Create anchor element
    const link = document.createElement("a");
    link.setAttribute("href", blobUrl);
    link.setAttribute("download", "Welcome Kit List.csv");

    // Append anchor element to the body and trigger click event
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    // const encodedUri = encodeURI(csvContent);
    // const link = document.createElement("a");
    // link.setAttribute("href", encodedUri);
    // link.setAttribute("download", "LeadList.csv");
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const submitfollowup = async () => {
    setIsFormSubmit(true);
    if (
      followUpData.next_f_date == "" ||
      followUpData.next_f_date == undefined ||
      followUpData.comment == null ||
      followUpData.comment == undefined
    ) {
      let notify = notification({
        type: "error",
        message: "Please enter all required fields to submit"
      });
      notify();
      setIsFormSubmit(false);
    } else {
      const resp = await insertWelcomeKitFollowUp(JSON.stringify(followUpData));

      if (resp.status == 1) {
        setFollowUpModal(false);
        setIsFormSubmit(false);
        setFollowUpData({ u_id: loginUser.u_id, m_id: memberHistory?.memberdetails?.m_id });
        setLeadHistory(await fetchPrimeleadhistory(myModal.p_lead_id));
        setMemberHistory(
          await fetchPrimeMemberWelcomeKithistory(memberHistory?.memberdetails?.m_id)
        );
      }
      let notify = notification({
        type: resp.status == 0 ? "error" : "success",
        message: resp.message
      });
      notify();
    }
  };

  const handleChange = (panel) => {
    setExpanded(expanded == panel ? -1 : panel);
  };

  return (
    <>
      <Modal
        style={{ overflow: "scroll" }}
        open={myModal.mval}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="div"
            component="div"
            style={{
              margin: "10px",
              textAlign: "center",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div style={{ width: "100%" }}>
              {/* {[0, 1, 2].includes(leadHistory?.leaddetails?.l_phase) && ( */}
              <Tooltip
                title="Add Followup"
                onClick={async () => {
                  await setFollowUpData({
                    ...followUpData,
                    p_lead_id: myModal.p_lead_id
                  });
                  await setFollowUpModal(true);
                }}
              >
                <IconButton>
                  <SendSharp color="info" />
                </IconButton>
              </Tooltip>
              {/* )} */}
            </div>
            {/* <div style={{ width: "100%" }}></div> */}
            <div style={{ display: "flex", justifyContent: "end" }}>
              <Tooltip
                title="Close"
                onClick={async () => {
                  await cancelModal();
                  setValue("1");
                }}
              >
                <IconButton>
                  <Close color="blank" />
                </IconButton>
              </Tooltip>
            </div>
          </Typography>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleTabChange} aria-label="lab API tabs example" centered>
                <Tab
                  icon={<LeaderboardSharp />}
                  iconPosition="end"
                  label="Member Details"
                  value="1"
                />
                <Tab icon={<ThumbUpAlt />} iconPosition="end" label="Follow Up History" value="3" />
                <Tab icon={<AutoGraphSharp />} iconPosition="end" label="Activity Log" value="2" />
              </TabList>
            </Box>
            <div
              style={{
                maxHeight: "500px",
                height: "500px",
                overflowY: "scroll"
              }}
            >
              <TabPanel value="1">
                <>
                  <Grid container spacing={2}>
                    <Grid xs={8} item>
                      {/* Personal Details Card */}
                      <Card style={{ border: "1px solid #abababb5" }}>
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Personal Information
                          </h3>
                          <Grid container spacing={0}>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Name </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.m_name || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>DOB </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.dob || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Contact No </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.mobile_no || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Email Id </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.m_email_id || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Address </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.b_address || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Joining Date </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.joining_date || "-"}
                                </p>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Card>

                      {/* Business Details Card */}
                      <Card
                        style={{
                          border: "1px solid #abababb5",
                          marginTop: "15px"
                        }}
                      >
                        <div>
                          <h3
                            style={{
                              padding: "15px",
                              background: "#1c4766",
                              color: "#fff"
                            }}
                          >
                            Business Information
                          </h3>

                          <Grid container spacing={0}>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Business Contact No </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.b_mobile_no || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Business Email Id </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.b_email_id || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Business Name</h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.business_name || "-"}
                                </p>
                              </div>
                            </Grid>

                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Business Category</h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.business_category || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Occupation Type</h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.occupation_type || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Welcome Kit Address</h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.pr_welcome_kit_address || "-"}
                                </p>
                              </div>
                            </Grid>
                            <Grid xs={6} item>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Pincode</h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.pr_pincode || "-"}
                                </p>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </Card>
                    </Grid>

                    {/* Right Side  */}
                    <Grid xs={4} item>
                      <div style={{ position: "sticky", top: "10px" }}>
                        <Card
                          style={{
                            border: "1px solid #abababb5"
                          }}
                        >
                          <div>
                            <h3
                              style={{
                                padding: "15px",
                                background: "#1c4766",
                                color: "#fff"
                              }}
                            >
                              Social Media
                            </h3>
                            <div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Website </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.website_url || "-"}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Facebook </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.fb || "-"}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Instagram </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.instagram || "-"}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Youtube </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.youtube || "-"}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Linkedin </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.linkedin || "-"}
                                </p>
                              </div>
                              <div
                                style={{
                                  margin: "5px 15px",
                                  paddingBottom: "5px",
                                  borderBottom: "1px solid #abababb5"
                                }}
                              >
                                <h4 style={{ color: "#838383" }}>Twitter </h4>
                                <p className="word-break-all">
                                  {memberHistory?.memberdetails?.twitter || "-"}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Card>
                      </div>
                    </Grid>
                  </Grid>
                </>
              </TabPanel>
              <TabPanel value="2">
                <Timeline position="right">
                  {memberHistory?.activitylog?.length > 0 ? (
                    memberHistory?.activitylog?.map((e) => {
                      return (
                        <TimelineItem>
                          <TimelineOppositeContent
                            color="text.secondary"
                            style={{
                              textAlign: "left",
                              width: "150px",
                              maxWidth: "150px"
                            }}
                          >
                            {e.date}
                          </TimelineOppositeContent>
                          <TimelineSeparator>
                            <TimelineDot color="primary" />
                            <TimelineConnector />
                          </TimelineSeparator>
                          <TimelineContent style={{ wordBreak: "break-word" }}>
                            <h4>{e.userName}</h4>

                            <p
                              style={{ whiteSpace: "pre-line" }}
                              dangerouslySetInnerHTML={{ __html: e.w_a_description }}
                            />
                          </TimelineContent>
                        </TimelineItem>
                      );
                    })
                  ) : (
                    <p style={{ textAlign: "center" }}>There is no records to display</p>
                  )}
                </Timeline>
              </TabPanel>
              <TabPanel value="3">
                <>
                  {memberHistory?.followupdetails?.length > 0 ? (
                    memberHistory?.followupdetails?.map((e, key) => {
                      return (
                        <Accordion
                          style={{
                            boxShadow: "#0000003d 0px 0px 6px 0px",
                            marginBottom: "10px",
                            borderRadius: "11px",
                            border: "1px solid #1c47669c"
                          }}
                          expanded={expanded === key}
                          onChange={() => handleChange(key)}
                        >
                          <AccordionSummary
                            style={{
                              background: "#1c4766",
                              color: "#fff",
                              borderRadius: "10px"
                            }}
                            aria-controls="panel1d-content"
                            id={key}
                            // panel1d-header
                          >
                            <Typography>{e.userName + " ( " + e.date + " )"}</Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography>
                              <p>Next Follow Date : {e.next_f_date}</p>
                              <p>Comment : {e.comment}</p>
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })
                  ) : (
                    <p style={{ textAlign: "center" }}>There is no records to display</p>
                  )}
                </>
              </TabPanel>
            </div>
          </TabContext>
        </Box>
      </Modal>
      <Modal
        open={followUpModal}
        onClose={cancelModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={followupstyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Follow Up
          </Typography>
          <div style={{ padding: "10px" }}>
            <div style={{ maxHeight: "320px" }}>
              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                <Card style={{ padding: "25px" }}>
                  <Stack spacing={10}>
                    <Grid container>
                      <Grid item xs={12}>
                        <Stack spacing={3} marginBottom={2}>
                          <LocalizationProvider
                            dateAdapter={AdapterDateFns}
                            adapterLocale={enGB}
                            style={{ marginTop: "15px" }}
                          >
                            <DatePicker
                              type="date"
                              name="next_f_date"
                              label="Next FollowUp date"
                              inputFormat="dd/MM/yyyy"
                              value={
                                followUpData.next_f_date
                                  ? new Date(
                                      followUpData.next_f_date.split("-").reverse().join("-")
                                    )
                                  : null
                              }
                              onChange={(newDate) => {
                                if (newDate instanceof Date && !isNaN(newDate)) {
                                  const day = String(newDate.getDate()).padStart(2, "0");
                                  const month = String(newDate.getMonth() + 1).padStart(2, "0");
                                  const year = newDate.getFullYear();
                                  setFollowUpData({
                                    ...followUpData,
                                    next_f_date: `${day}-${month}-${year}`
                                  });
                                }
                              }}
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  required: true
                                }
                              }}
                            />
                          </LocalizationProvider>
                        </Stack>
                      </Grid>
                      <Grid item xs={12}>
                        <Stack spacing={3}>
                          <TextField
                            required
                            multiline
                            rows={4}
                            fullWidth
                            label="Comment"
                            name="comment"
                            value={followUpData?.comment || ""}
                            onChange={(e) => {
                              setFollowUpData({
                                ...followUpData,
                                comment: e.target.value
                              });
                            }}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Card>
              </Stack>
            </div>
            <hr />
            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => {
                  setFollowUpModal(false);
                  setIsFormSubmit(false);
                  setFollowUpData({
                    u_id: loginUser.u_id,
                    m_id: memberHistory?.memberdetails?.m_id
                  });
                }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                onClick={submitfollowup}
                disabled={isFormSubmit}
                startIcon={isFormSubmit && <CircularProgress size={20} color="inherit" />}
              >
                Confirm
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={leadStatusChangeModal}
        onClose={closeLeadStatusChangeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={followupstyle}>
          <Typography
            align="center"
            id="modal-modal-title"
            variant="h4"
            component="h2"
            style={{ borderBottom: "2px solid #000" }}
          >
            Update Welcome Kit Status
          </Typography>
          <div style={{ padding: "10px" }}>
            {statusList?.map((status) => {
              const currentPhase = leadStatusChangeData?.from_l_phase;

              return (
                <div
                  value={status?.value}
                  style={{
                    position: "relative",
                    marginBottom: "10px",
                    border: currentPhase === status?.value ? "none" : "2px solid #1c4766",
                    padding: "7px 15px",
                    borderRadius: "10px",
                    background: currentPhase === status?.value ? "#1c4766" : "#fff",
                    color: currentPhase === status?.value ? "#fff" : "#000",
                    cursor: "pointer",
                    pointerEvents: "auto",
                    WebkitUserSelect: "none", // Optional: Disable text selection on double-click
                    MozUserSelect: "none", // Optional: Disable text selection on double-click
                    msUserSelect: "none", // Optional: Disable text selection on double-click
                    userSelect: "none" // Optional: Disable text selection on double-click
                  }}
                  onClick={async (e) => {
                    const divValue = e.currentTarget.getAttribute("value");
                    await welcomeKitStatusChange(
                      leadStatusChangeData.m_id,
                      divValue,
                      leadStatusChangeData.from_l_phase
                    );
                  }}
                >
                  <a id="">{status.label}</a>
                  {currentPhase === status?.value && (
                    <Check color="#fff" style={{ position: "absolute", right: "10" }} />
                  )}
                </div>
              );
            })}
            <hr />

            <div
              style={{
                margin: "10px auto",
                display: "flex",
                justifyContent: "space-between"
              }}
            >
              <Button variant="outlined" onClick={closeLeadStatusChangeModal}>
                Close
              </Button>
            </div>
          </div>
        </Box>
      </Modal>

      <Page title="Welcome Kit | Local Vocal Business Group">
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4" gutterBottom>
              Welcome Kit
            </Typography>
            <Button
              className="btn btn-export"
              style={{ marginBottom: "15px", marginTop: "0" }}
              variant="contained"
              onClick={exportFilteredData}
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? "Exporting..." : "Export CSV"}
            </Button>
          </Stack>
          <>
            <Card className="p-20">
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <TextField
                      fullWidth
                      value={filterlead?.filterl}
                      autoComplete="off"
                      type="text"
                      label="Search Member"
                      name="search"
                      onChange={(e) => {
                        setfilterlead({
                          ...filterlead,
                          filterl: e.target.value
                        });
                      }}
                    />
                  </Stack>
                </Grid>

                <Grid item xs={3}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={enGB}
                      style={{ marginTop: "15px" }}
                    >
                      <DatePicker
                        type="date"
                        name="s_date"
                        label="Start Date "
                        inputFormat="dd/MM/yyyy"
                        value={
                          filterlead.s_date
                            ? new Date(filterlead.s_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                            : null
                        }
                        onChange={(newDate) => {
                          if (newDate instanceof Date && !isNaN(newDate)) {
                            const day = String(newDate.getDate()).padStart(2, "0");
                            const month = String(newDate.getMonth() + 1).padStart(2, "0");
                            const year = newDate.getFullYear();
                            setfilterlead({
                              ...filterlead,
                              s_date: `${day}-${month}-${year}`
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
                <Grid item xs={3}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      adapterLocale={enGB}
                      style={{ marginTop: "15px" }}
                    >
                      <DatePicker
                        type="date"
                        name="e_date"
                        label="End Date "
                        inputFormat="dd/MM/yyyy"
                        value={
                          filterlead.e_date
                            ? new Date(filterlead.e_date.split("-").reverse().join("-")) // Converts "DD-MM-YYYY" to "YYYY-MM-DD"
                            : null
                        }
                        onChange={(newDate) => {
                          if (newDate instanceof Date && !isNaN(newDate)) {
                            const day = String(newDate.getDate()).padStart(2, "0");
                            const month = String(newDate.getMonth() + 1).padStart(2, "0");
                            const year = newDate.getFullYear();
                            setfilterlead({
                              ...filterlead,
                              e_date: `${day}-${month}-${year}`
                            });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} onKeyDown={(e) => e.preventDefault()} />
                        )}
                      />
                    </LocalizationProvider>
                  </Stack>
                </Grid>
                <Grid item xs={3}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <label>Welcome Kit Address</label>
                    <Select
                      //filter.address_filled
                      value={
                        filterlead.address_filled == 0
                          ? { value: 0, label: "All" }
                          : addressFiledData?.map((st) => {
                              if (st.value == filterlead.address_filled) {
                                return { value: st.value, label: st.label };
                              }
                            })
                      }
                      menuPortalTarget={document.body}
                      onChange={(e) => {
                        setfilterlead({
                          ...filterlead,
                          address_filled: e.value
                        });
                      }}
                      options={[{ value: 0, label: "All" }, ...addressFiledData]}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={3}>
                  <Stack spacing={3} style={{ marginBottom: "15px" }}>
                    <label>All Welcome Kit Status</label>
                    <Select
                      //filter.lead_status
                      value={
                        filterlead.lead_status == -1
                          ? { value: -1, label: "All Welcome Kit Status" }
                          : statusList?.map((st) => {
                              if (st.value == filterlead.lead_status) {
                                return { value: st.value, label: st.label };
                              }
                            })
                      }
                      menuPortalTarget={document.body}
                      onChange={(e) => {
                        setfilterlead({
                          ...filterlead,
                          lead_status: e.value
                        });
                      }}
                      options={[{ value: -1, label: "All Welcome Kit Status" }, ...statusList]}
                    />
                  </Stack>
                </Grid>
                <Grid item xs={2}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around"
                    }}
                  >
                    <Button
                      style={{ marginTop: "15px" }}
                      onClick={() => {
                        setLoadingMoreData(-1);
                        getFilterLeadData();
                      }}
                      variant="contained"
                    >
                      search
                    </Button>
                    <Button
                      style={{ marginTop: "15px" }}
                      onClick={async () => {
                        await setLoadingMoreData(-1);
                        await setfilterlead({
                          u_type: loginUser.u_type,
                          filterl: "",
                          s_date: null,
                          e_date: null,
                          l_phase: -1,
                          lead_status: -1,
                          address_filled: 0
                        });
                        await resetSearchForm({
                          u_type: loginUser.u_type,
                          filterl: "",
                          s_date: null,
                          e_date: null,
                          l_phase: -1,
                          lead_status: -1,
                          address_filled: 0
                        });
                      }}
                      variant="contained"
                    >
                      clear
                    </Button>
                  </div>
                </Grid>
              </Grid>
            </Card>
            {step == 0 &&
              (loading ? (
                <CustomLoader />
              ) : (
                <Board
                  className="taskList"
                  data={leadList}
                  style={{ position: "relative", marginTop: "15px" }}
                  components={{ Card: CustomCard }}
                  onCardClick={async (cardId, metadata, phase) => {
                    setValue("1");
                    setMyModal({
                      mval: true,
                      m_id: cardId,
                      l_phase: phase
                    });
                    setMemberHistory(await fetchPrimeMemberWelcomeKithistory(cardId));
                    setExpanded(0);
                  }}
                  handleDragEnd={async (id, sourceLaneId, targetLaneId) => {
                    await welcomeKitStatusChange(id, targetLaneId, sourceLaneId);
                  }}
                  // onLaneScroll={(requestedPage, laneId) => handleCustomLaneScroll(laneId, false)}
                  onLaneScroll={(_, laneId) => handleCustomLaneScroll(Number(laneId))}
                />
              ))}
          </>
        </Container>
      </Page>
    </>
  );
}
